import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'
import { useLightMode } from '@/hooks/useLightMode'
import { useDispatch } from 'react-redux'

import { Box, CloseButton } from '@chakra-ui/react'

import {
  CloseIcon,
  Box as DarkBox,
  IconButton,
  tokenPrefix,
} from '@hivewatch/dark'

import { toggleIncidentTraceLogDrawer } from '@/redux/ui/uiSlice'

export const TraceLogHeader = () => {
  const dispatch = useDispatch()
  const isRebrand = useFeatureFlag(FeatureFlag.incidentDrawerRebrand)
  const mode = useLightMode()

  // Rendered inside TraceLogContent's DarkProvider when the rebrand flag is
  // on, so no provider of its own — see WorkflowDrawerHeader for the
  // standalone variant.
  if (isRebrand) {
    const prefix = tokenPrefix(mode)
    return (
      <DarkBox
        alignItems='center'
        borderBottom='1px solid'
        borderColor={`${prefix}border.subtle`}
        display='flex'
        flexShrink={0}
        gap='12px'
        justifyContent='space-between'
        px='24px'
        py='16px'
      >
        <DarkBox
          as='span'
          color={`${prefix}text.primary`}
          fontFamily="'Soehne Kraftig', 'Söhne Kräftig', sans-serif"
          fontSize='20px'
          fontWeight='500'
          lineHeight='28px'
          whiteSpace='nowrap'
        >
          Trace Logs
        </DarkBox>
        <IconButton
          _active={{ bg: 'transparent' }}
          aria-label='close trace log drawer'
          colorScheme={mode}
          dimension={36}
          hoverBgColor='transparent'
          icon={<CloseIcon size={11} />}
          onClick={() => dispatch(toggleIncidentTraceLogDrawer())}
        />
      </DarkBox>
    )
  }

  return (
    <Box
      alignItems='center'
      borderBottom='1px solid #D5DCE4'
      display='flex'
      h='65px'
      justifyContent='space-between'
      px='24px'
    >
      <Box color='black' fontSize='20px' fontWeight='extrabold'>
        Trace Logs
      </Box>
      <CloseButton
        ml={4}
        onClick={() => dispatch(toggleIncidentTraceLogDrawer())}
      />
    </Box>
  )
}
